import { Chip, Collapse, Container, Grid, useTheme } from '@material-ui/core';
import { DigitalWindowIcon, DuvidaIcon, InvertedChevronIcon } from 'components/Icons';
import PublicContainer from 'components/PublicContainer';
import { basePath } from 'library/Routes';
import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Footer from './Footer';
import useStyles from './style';

export const MIN_LENGHT = 11;
export const MAX_LENGHT = 18;

const fixedContainerId: string = 'fixed-container';
const fixedTitleContainerId: string = 'fixed-title-container';
const leftTitleId: string = 'left-title';
const rightTitleId: string = 'right-title';
const leftCardId: string = 'left-card';
const rightCardId: string = 'right-card';
const leftContentId: string = 'left-text';
const rightContentId: string = 'right-text';

const Consulta = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const theme = useTheme();
  const [leftCollapse, setLeftCollapse] = useState<boolean>(false);
  const [rightCollapse, setRightCollapse] = useState<boolean>(false);
  const [contentHeight, setContentHeight] = useState<number>(0);
  const [titleHeight, setTitleHeight] = useState<number>(0);
  const [leftContentWidth, setLeftContentWidth] = useState<number>(0);
  const [rightContentWidth, setRightContentWidth] = useState<number>(0);
  const [leftTitleWidth, setLeftTitleWidth] = useState<number>(0);
  const [rightTitleWidth, setRightTitleWidth] = useState<number>(0);

  const onResized = useCallback(() => {
    const leftCardElement: HTMLElement | null = document.getElementById(leftCardId);
    const rightCardElement: HTMLElement | null = document.getElementById(rightCardId);
    setLeftContentWidth(leftCardElement ? parseInt(window.getComputedStyle(leftCardElement).width) : 0);
    setRightContentWidth(rightCardElement ? parseInt(window.getComputedStyle(rightCardElement).width) : 0);
    const leftTitleElement: HTMLElement | null = document.getElementById(leftTitleId);
    const rightTitleElement: HTMLElement | null = document.getElementById(rightTitleId);
    setLeftTitleWidth(leftTitleElement ? parseInt(window.getComputedStyle(leftTitleElement).width) + theme.spacing(4) : 0);
    setRightTitleWidth(rightTitleElement ? parseInt(window.getComputedStyle(rightTitleElement).width) + theme.spacing(4) : 0);
  }, [setLeftContentWidth, setRightContentWidth, setLeftTitleWidth, setRightTitleWidth, theme])

  useEffect(() => {
    const fixedContainerElement: HTMLElement | null = document.getElementById(fixedContainerId);
    setContentHeight(fixedContainerElement ? (parseInt(window.getComputedStyle(fixedContainerElement).height) - theme.spacing(4)) : 0);
    const fixedTitleContainerElement: HTMLElement | null = document.getElementById(fixedTitleContainerId);
    setTitleHeight(fixedTitleContainerElement ? parseInt(window.getComputedStyle(fixedTitleContainerElement).height) : 0);
  }, [
    leftContentWidth,
    rightContentWidth,
    leftTitleWidth,
    rightTitleWidth,
    setContentHeight,
    setTitleHeight,
    theme
  ])

  useLayoutEffect(() => {
    onResized();
    window.addEventListener('resize', onResized);
    return () => window.removeEventListener('resize', onResized);
  }, [onResized])

  return (
    <PublicContainer>
      <div
        id={fixedTitleContainerId}
        className={classes.fixedTitles}
        style={{
          width: `${leftTitleWidth + rightTitleWidth}px`
        }}
      >
        <div
          className={classes.cardTitle}
          style={{
            width: `${leftTitleWidth}px`
          }}
        >
          {t(`Consulta.leftCard.title`)}
        </div>
        <div
          className={classes.cardTitle}
          style={{
            width: `${rightTitleWidth}px`
          }}
        >
          {t(`Consulta.rightCard.title`)}
        </div>
      </div>
      <div
        id={fixedContainerId}
        className={classes.fixedContents}
        style={{
          width: `${leftContentWidth + rightContentWidth}px`
        }}
      >
        <div
          className={[
            classes.fixedContentItem,
            classes.collapseContent,
          ].join(' ')}
          style={{
            width: `${leftContentWidth}px`
          }}
          dangerouslySetInnerHTML={{ __html: t(`Consulta.leftCard.content`) }}
        />
        <div
          className={[
            classes.fixedContentItem,
            classes.collapseContent,
          ].join(' ')}
          style={{
            width: `${rightContentWidth}px`
          }}
          dangerouslySetInnerHTML={{ __html: t(`Consulta.rightCard.content`) }}
        />
      </div>
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid item xs={12} className={classes.headerContent}>
            <div className={classes.leftHeader}>
              <h6 className={classes.suptitle}>
                {t(`Consulta.suptitle`)}
              </h6>
              <h1 className={classes.title}>
              {t(`Consulta.title`)}
              </h1>
              <h4 className={classes.subtitle}>
              {t(`Consulta.subtitle`)}
              </h4>
              <Grid container spacing={3} className={classes.headerFooter}>
                <Grid item sm={6}>
                  <div className={classes.card} id={leftCardId}>
                    <button className={classes.cardHeaderButton} onClick={() => setLeftCollapse(!leftCollapse)}>
                      <DigitalWindowIcon />
                      <div
                        id={leftTitleId}
                        className={classes.cardTitle}
                        style={{
                          minHeight: `${titleHeight}px`,
                        }}
                      >
                        {t(`Consulta.leftCard.title`)}
                      </div>
                      <InvertedChevronIcon className={[
                        classes.collapseIcon,
                        leftCollapse ? classes.openedCollapseIcon : ''
                      ].join(' ')} />
                    </button>
                    <Collapse in={leftCollapse}>
                      <div className={classes.collapseContent}>
                        <span
                          id={leftContentId}
                          dangerouslySetInnerHTML={{ __html: t(`Consulta.leftCard.content`) }}
                          style={{
                            minHeight: `${contentHeight}px`,
                            display: 'block',
                          }}
                        />
                      </div>
                    </Collapse>
                  </div>
                </Grid>
                <Grid item sm={6}>
                  <div className={classes.card} id={rightCardId}>
                    <button className={classes.cardHeaderButton} onClick={() => setRightCollapse(!rightCollapse)}>
                      <DuvidaIcon />
                      <div
                        id={rightTitleId}
                        className={classes.cardTitle}
                        style={{
                          minHeight: `${titleHeight}px`,
                        }}
                      >
                        {t(`Consulta.rightCard.title`)}
                      </div>
                      <InvertedChevronIcon className={[
                        classes.collapseIcon,
                        rightCollapse ? classes.openedCollapseIcon : ''
                      ].join(' ')} />
                      <Chip className={classes.newsChip} label={t(`Consulta.rightCard.chipTitle`)} />
                    </button>
                    <Collapse in={rightCollapse}>
                      <div className={classes.collapseContent}>
                        <span
                          id={rightContentId}
                          dangerouslySetInnerHTML={{ __html: t(`Consulta.rightCard.content`) }}
                          style={{
                            minHeight: `${contentHeight}px`,
                            display: 'block',
                          }}
                        />
                      </div>
                    </Collapse>
                  </div>
                </Grid>
              </Grid>
            </div>
            <div className={classes.rightHeader}>
              <img
                src={`${basePath}images/inicial.png`}
                alt=""
                className={classes.rightImage}
              />
            </div>
          </Grid>
        </Grid>
        <Footer />
      </Container>
    </PublicContainer>
  );
};

export default Consulta;
